import React from "react";

import WmsModel from "../../../../components/WmsModel/WmsModel.jsx";
import WmsContainer from "../../../../components/WmsContainer/WmsContainer.jsx";
import WmsButton from "../../../../components/WmsButton/WmsButton.jsx";
import WmsDropdown from "../../../../components/WmsDropdown/WmsDropdown.jsx";
import "./reprint-shipping-label.scss";
import { ObjectWms } from "../../../../../../assets/ts/ObjectWms.ts";
import * as GlobalService from "./../../../../global_services";
import * as smallParcelSettingsServices from "../../../../smallParcelSettings/small-parcel-settings.services.jsx";
import * as smallParcelService from "../../../../smallParcel/smallParcel.service.jsx";
import * as papiDocumentUtil from "../../../../smallParcel/papi-document.util.js";
import axios from "axios";

export class ReprintShippingLabel extends React.Component {
    constructor(props) {
        super(props);

        this.translate = window.translate;
        this.modalId = "#ReprintShippingLabel";
        this._allDocumentTemplates = [];

        this.state = {
            selector: "FindOrderReprintShippingLabel",
            shippingLabelGenerateGif: false,
            modalReady: false,
            shippingLabelOptions: [],
            shippingLabelSelectedIndex: 0,
            optionsPackingReports: [],
            indexOptionsPackingReports: 0,
            indexPapiPackSlipScope: "shipment",
            useNewPackingSlipFeatures: false,
            showMixedCustomerNewPackingSlipWarning: false,
        };
        this.optionsPapiPackSlipScope = [
            { text: this.translate("Label_PapiPackSlipLayout_PerOrder"), value: "shipment" },
            { text: this.translate("Label_PapiPackSlipLayout_PerPackage"), value: "package" },
        ];
        this._customersSettingsResponse = null;
        this._reprintLoadToken = 0;
    }

    componentDidMount() {
        this.loadSettingsAndInitialize();
    }

    componentWillUnmount() {
        this._reprintLoadToken += 1;
        this.setModalLoading(false);
    }

    setModalLoading = (show) => {
        window.setTimeout(() => {
            var el = $(this.modalId);
            if (el && el.length) {
                kendo.ui.progress(el, show);
            }
        }, 0);
    };

    loadSettingsAndInitialize = () => {
        var loadToken = ++this._reprintLoadToken;
        if (this.props.papiReprintAllowed === false) {
            this._customersSettingsResponse = null;
            this.setState({
                useNewPackingSlipFeatures: false,
                showMixedCustomerNewPackingSlipWarning: false,
                modalReady: false,
            }, () => {
                if (loadToken !== this._reprintLoadToken) {
                    return;
                }
                this.initializeReprintModal();
            });
            return;
        }
        this.setModalLoading(true);
        var customerIds = this.getSelectedCustomerIds();
        if (!customerIds.length) {
            if (this.shouldLegacyZplFallback(false)) {
                this.runLegacyZplFallback(loadToken);
                return;
            }
            this.setState({
                useNewPackingSlipFeatures: false,
                showMixedCustomerNewPackingSlipWarning: false,
                modalReady: false,
            }, () => {
                if (loadToken !== this._reprintLoadToken) {
                    return;
                }
                this.initializeReprintModal();
            });
            return;
        }
        smallParcelService.getCustomersSettings(customerIds).then((response) => {
            if (loadToken !== this._reprintLoadToken) {
                return;
            }
            var rights = GlobalService.GetRights();
            var settingsOn = smallParcelService.customersSettingsUseNewPackingSlipFeatures(
                response,
                customerIds
            );
            var optedInCustomer = null;
            if (response && response.data) {
                response.data.some(function (customer) {
                    if (papiDocumentUtil.isCustomerUsingNewPackingSlipFeatures(customer)) {
                        optedInCustomer = customer;
                        return true;
                    }
                    return false;
                });
            }
            var useNewPackingSlipFeatures = settingsOn && papiDocumentUtil.usesNewPackingSlipUi(
                rights,
                optedInCustomer
            );
            var showMixedCustomerNewPackingSlipWarning = smallParcelService.mixedCustomersMissingNewPackingSlipFeatures(
                response,
                customerIds
            );
            if (this.shouldLegacyZplFallback(useNewPackingSlipFeatures, showMixedCustomerNewPackingSlipWarning)) {
                this.runLegacyZplFallback(loadToken);
                return;
            }
            this._customersSettingsResponse = response;
            this.setState({
                useNewPackingSlipFeatures: useNewPackingSlipFeatures,
                showMixedCustomerNewPackingSlipWarning: showMixedCustomerNewPackingSlipWarning,
                modalReady: false,
            }, () => {
                if (loadToken !== this._reprintLoadToken) {
                    return;
                }
                this.initializeReprintModal();
            });
        }).catch(() => {
            if (loadToken !== this._reprintLoadToken) {
                return;
            }
            if (this.shouldLegacyZplFallback(false)) {
                this.runLegacyZplFallback(loadToken);
                return;
            }
            this._customersSettingsResponse = null;
            var showMixedCustomerNewPackingSlipWarning = this.isMixedCustomerSelection();
            this.setState({
                useNewPackingSlipFeatures: false,
                showMixedCustomerNewPackingSlipWarning: showMixedCustomerNewPackingSlipWarning,
                modalReady: false,
            }, () => {
                if (loadToken !== this._reprintLoadToken) {
                    return;
                }
                this.initializeReprintModal();
            });
        });
    };

    shouldLegacyZplFallback = (useNewPackingSlipFeatures, showMixedCustomerNewPackingSlipWarning) => {
        if (showMixedCustomerNewPackingSlipWarning) {
            return false;
        }
        return this.props.parcelLabelType == 2
            && !useNewPackingSlipFeatures
            && typeof this.props.onLegacyReprintFallback === "function";
    };

    runLegacyZplFallback = (loadToken) => {
        if (loadToken !== this._reprintLoadToken) {
            return;
        }
        this.setModalLoading(false);
        this.props.onCloseReprintShippingLabel();
        this.props.onLegacyReprintFallback();
    };

    getSelectedCustomerIds = () => {
        return papiDocumentUtil.distinctWmsCustomerIds(
            this.props.sharedSelectedCustomerIds && this.props.sharedSelectedCustomerIds.length
                ? this.props.sharedSelectedCustomerIds
                : (this.props.sharedSelectedOrderData && this.props.sharedSelectedOrderData.CustomerId)
        );
    };

    isMixedCustomerSelection = () => {
        return this.getSelectedCustomerIds().length > 1;
    };

    getReprintCustomerApiFields = () => {
        var ids = this.getSelectedCustomerIds();
        if (ids.length <= 1) {
            return { CustomerId: ids[0] || null };
        }
        return { CustomerIds: ids };
    };

    getCustomerContainerTitle = () => {
        var prefix = this.translate("FindOrders_Lbl_Customer") + ": ";
        if (this.isMixedCustomerSelection()) {
            return prefix + this.translate("Label_Multiples_Text");
        }
        return prefix + (this.props.sharedSelectedOrderData != null
            ? this.props.sharedSelectedOrderData.Customer
            : "");
    };

    initializeReprintModal = () => {
        this.setModalLoading(true);
        if (this.state.useNewPackingSlipFeatures) {
            if (this.props.parcelLabelType != 2) {
                this.loadLabelTemplateOptions();
            }
            this.loadNewPackingSlipOptions(this._customersSettingsResponse);
            return;
        }
        if (this.props.parcelLabelType != 2) {
            this.loadLabelTemplateOptions();
        }
        this.setModalLoading(false);
        this.setState({ modalReady: true });
    };

    loadLabelTemplateOptions = () => {
        var shippinglabelindex = ObjectWms.FindIndexByProperty(
            this.props.SharedReprintLabelsReport,
            "CategoryName",
            "Reprint Shipping Label"
        );
        if (shippinglabelindex == -1) {
            this.setState({ shippingLabelOptions: [], shippingLabelSelectedIndex: 0 });
            return;
        }
        var labelReports = this.props.SharedReprintLabelsReport[shippinglabelindex].Reports;
        var customerIds = this.getSelectedCustomerIds();
        var tmpShippingLabelOptions = [];
        labelReports.forEach((report) => {
            var runner = report.TemplatedRunner || "";
            if (runner.indexOf("customerid=") === -1) {
                tmpShippingLabelOptions.push(report);
            } else if (customerIds.some(function (customerId) {
                return runner.indexOf("customerid=" + customerId) !== -1;
            })) {
                tmpShippingLabelOptions.push(report);
            }
        });
        this.setState({ shippingLabelOptions: tmpShippingLabelOptions });
    };

    handleChangeShippingLabel = (e) => {
        this.setState({ shippingLabelSelectedIndex: e.target.value });
    };

    getLabelFormat = () => {
        return this.props.parcelLabelType == 2 ? "zpl" : "pdf";
    };

    showPackingSlipLayout = () => {
        return papiDocumentUtil.isPapiSelection(this.state.indexOptionsPackingReports);
    };

    getModalHeight = () => {
        var height = 230;
        if (!this.state.modalReady) {
            return height;
        }
        if (this.state.useNewPackingSlipFeatures) {
            height = 300;
            if (this.showPackingSlipLayout()) {
                height += 70;
            }
        }
        if (this.state.showMixedCustomerNewPackingSlipWarning) {
            height += 48;
        }
        return height;
    };

    handleChangeEvent = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    rebuildPapiPackingSlipTypeOptions = (savedValue, autoSelectFirst) => {
        const options = papiDocumentUtil.buildDocumentTypeOptions({
            docTypeKey: "packingSlip",
            papiTemplates: this._allDocumentTemplates,
            format: this.getLabelFormat(),
            wmsCustomerIds: this.getSelectedCustomerIds(),
            includeDraft: false,
            includeEmptyRow: true,
        });
        const selection = papiDocumentUtil.resolveTemplateSelection(
            options,
            savedValue,
            autoSelectFirst !== false
        );
        return { options, selection };
    };

    loadNewPackingSlipOptions = (settingsResponse) => {
        const loadToken = this._reprintLoadToken;
        this._allDocumentTemplates = [];
        const schemaPromise = smallParcelSettingsServices.getCarrierAccountSchema().catch(() => null);

        Promise.all([schemaPromise, Promise.resolve(settingsResponse || null)]).then(([schemaResponse, settingsResponseResolved]) => {
            if (loadToken !== this._reprintLoadToken) {
                return;
            }
            if (schemaResponse && schemaResponse.status == 200) {
                const parsedTemplates = papiDocumentUtil.parseDocumentTemplatesFromSchemaResponse(
                    schemaResponse.data
                );
                this._allDocumentTemplates = parsedTemplates == null
                    ? (this._allDocumentTemplates || [])
                    : parsedTemplates;
            }
            let packaging = null;
            if (!this.isMixedCustomerSelection()
                && settingsResponseResolved
                && settingsResponseResolved.data
                && settingsResponseResolved.data.length > 0) {
                packaging = settingsResponseResolved.data[0].Options
                    && settingsResponseResolved.data[0].Options.Packaging;
            }
            // Not Included is always the default so a reprint can be labels only.
            const rebuilt = this.rebuildPapiPackingSlipTypeOptions(null, false);
            const savedScope = (packaging && (packaging.SmallParcelPapiPackSlipScope
                || packaging.smallParcelPapiPackSlipScope)) || "shipment";
            this.setState({
                optionsPackingReports: rebuilt.options,
                indexOptionsPackingReports: rebuilt.selection.value,
                indexPapiPackSlipScope: savedScope,
                modalReady: true,
            });
        }).catch(() => {
            if (loadToken !== this._reprintLoadToken) {
                return;
            }
            this.setState({ modalReady: true });
        }).finally(() => {
            if (loadToken !== this._reprintLoadToken) {
                return;
            }
            this.setModalLoading(false);
        });
    };

    getPackingSlipReprintArgs = () => {
        const parsed = papiDocumentUtil.parseDocOptionValue(this.state.indexOptionsPackingReports);
        const templateId = parsed.rawId;
        return {
            papiTemplateId: templateId,
            papiTemplateVersion: papiDocumentUtil.findPapiTemplateVersion(
                this.state.optionsPackingReports,
                templateId
            ),
            papiSlipScope: this.state.indexPapiPackSlipScope || "shipment",
        };
    };

    notifyReprintGenerateFailed = (error) => {
        const message = papiDocumentUtil.extractPapiErrorMessage(error)
            || this.translate("Label_Reprint_Labels_Generate_Error");
        GlobalService.notification("error", this.translate("Label_Reprint_Labels"), message);
    };

    notifyReprintSlipWarning = (slipWarning) => {
        if (!slipWarning) {
            return;
        }
        GlobalService.notification("warning", this.translate("Label_Reprint_Labels"), slipWarning);
    };

    handlePapiReprintPdfResponse = (response) => {
        if (!response || response.status !== 200) {
            return Promise.reject(response);
        }
        var parsed = papiDocumentUtil.parsePapiReprintPdfJsonResponse(response.data);
        var blob = parsed && parsed.pdfBlob;
        if (!blob) {
            return Promise.reject(response);
        }
        GlobalService.printOrViewPdf(
            blob,
            "application/pdf",
            "ShippingLabel-" + kendo.toString(kendo.parseDate(new Date()), "yyyyMMddhhmmss") + ".pdf",
            false
        );
        this.notifyReprintSlipWarning(parsed && parsed.slipWarning);
    };

    handlePapiReprintZplResponse = (response) => {
        if (!response || (response.status !== 200 && response.status !== 204)) {
            return Promise.reject(response);
        }
        var parsed = papiDocumentUtil.parsePapiReprintZplJsonResponse(response.data);
        var labels = parsed && parsed.labels;
        if (!labels) {
            var decoded = papiDocumentUtil.decodeZplResponseData(response.data);
            if (typeof decoded === "string" && decoded.trim()) {
                labels = [decoded];
            }
        }
        if (!labels || !labels.length) {
            return Promise.reject(response);
        }
        GlobalService.printDataInZplPrinter(labels);
        this.notifyReprintSlipWarning(parsed && parsed.slipWarning);
    };

    generateLabel = () => {
        if (this.state.useNewPackingSlipFeatures && this.showPackingSlipLayout()) {
            this.setState({ shippingLabelGenerateGif: true });
            this.reprintLabels()
                .then(() => {
                    this.props.onCloseReprintShippingLabel();
                })
                .catch((error) => {
                    this.setState({ shippingLabelGenerateGif: false });
                    this.notifyReprintGenerateFailed(error);
                });
            return;
        }
        if (this.props.parcelLabelType == 2) {
            if (typeof this.props.onLegacyReprintFallback === "function") {
                this.runLegacyZplFallback(this._reprintLoadToken);
            }
            return;
        }
        this.generatePDF();
    };

    generatePDF = () => {
        if (this._pdfReprintInFlight) {
            return;
        }
        var selectReportLabel = this.state.shippingLabelOptions[this.state.shippingLabelSelectedIndex];
        if (!selectReportLabel) {
            this.notifyReprintGenerateFailed();
            return;
        }
        this._pdfReprintInFlight = true;
        this.setState({ shippingLabelGenerateGif: true });
        var customerFields = this.getReprintCustomerApiFields();
        var pdfDownloadLink =
            "/WebUI/Shipping/FindOrders/ParcelReprintPdfContent?orderIds=" +
            this.props.SharedSelectedOrderIds.toString() +
            "&templatedRunnerKey=" +
            selectReportLabel.TemplatedRunnerKey;
        if (customerFields.CustomerIds) {
            pdfDownloadLink += "&customerIds=" + customerFields.CustomerIds.join(",");
        } else {
            pdfDownloadLink += "&customerId=" + customerFields.CustomerId;
        }
        axios
            .get(pdfDownloadLink, { responseType: "blob" })
            .then((response) => {
                GlobalService.printOrViewPdf(
                    response.data,
                    "application/pdf",
                    "ShippingLabel-" + kendo.toString(kendo.parseDate(new Date()), "yyyyMMddhhmmss") + ".pdf",
                    false
                );
                this.props.onCloseReprintShippingLabel();
            })
            .catch((error) => {
                this.notifyReprintGenerateFailed(error);
            })
            .finally(() => {
                this._pdfReprintInFlight = false;
                this.setState({ shippingLabelGenerateGif: false });
            });
    };

    applyPackingSlipArgs = (body, packingSlipArgs) => {
        body.OutputFormat = this.getLabelFormat();
        body.PapiTemplateId = packingSlipArgs.papiTemplateId || null;
        body.PapiTemplateVersion = packingSlipArgs.papiTemplateVersion || null;
        body.PapiSlipScope = packingSlipArgs.papiSlipScope || null;
        return body;
    };

    reprintLabels = () => {
        var body = this.applyPackingSlipArgs(Object.assign({
            TransactionIds: this.props.SharedSelectedOrderIds,
        }, this.getReprintCustomerApiFields()), this.getPackingSlipReprintArgs());
        if (this.props.parcelLabelType == 2) {
            return axios
                .post("/WebUI/Shipping/FindOrders/ParcelReprintWithPackingSlipsZplContent", body)
                .then((response) => this.handlePapiReprintZplResponse(response));
        }
        return axios
            .post("/WebUI/Shipping/FindOrders/ParcelReprintWithPackingSlipsPdfContent", body)
            .then((response) => this.handlePapiReprintPdfResponse(response));
    };

    getAnyNotFullyPackageAllocated = () => {
        if (this.props.sharedAnyNotFullyPackageAllocated === true) {
            return true;
        }
        var d = this.props.sharedSelectedOrderData;
        if (d && d.FullyPackageAllocated === false) {
            return true;
        }
        if (d && d.ReadOnly && d.ReadOnly.FullyPackageAllocated === false) {
            return true;
        }
        return false;
    };

    isPapiPackageLayoutBlocked = () => {
        return papiDocumentUtil.shouldDisablePapiPackingSlipsForSelection(
            papiDocumentUtil.isPapiSelection(this.state.indexOptionsPackingReports),
            papiDocumentUtil.isPapiPackageSlipScope(this.state.indexPapiPackSlipScope),
            this.getAnyNotFullyPackageAllocated()
        );
    };

    render() {
        const useNewPackingSlipFeatures = this.state.useNewPackingSlipFeatures;
        const showLegacyTemplateOptions = this.state.modalReady
            && !useNewPackingSlipFeatures
            && this.props.parcelLabelType != 2;
        const showPackingSlipOptions = this.state.modalReady && useNewPackingSlipFeatures;
        const isPapiPackageLayoutBlocked = showPackingSlipOptions && this.isPapiPackageLayoutBlocked();
        const generateDisabled = this.state.shippingLabelGenerateGif
            || !this.state.modalReady
            || isPapiPackageLayoutBlocked;
        return (
            <WmsModel
                id={"ReprintShippingLabel"}
                class="reprint-shipping-label-wrapper"
                title={this.translate("Label_Reprint_Shipping_Labels")}
                width={500}
                onCloseFunc={this.props.onCloseReprintShippingLabel}
                height={this.getModalHeight()}
                isOpen={this.props.sharedIsReprintShippingLabelOpen}
                customClass="wms-model-new-ui-wrapper"
            >
                <div className="model-content-wrapper">
                    {this.state.modalReady && this.state.showMixedCustomerNewPackingSlipWarning && (
                        <p className="reprint-shipping-label-new-packing-slip-warning" role="alert">
                            {this.translate(this.props.parcelLabelType == 2
                                ? "Label_Reprint_Mixed_Customers_Setting_Not_All_Enabled"
                                : "Label_Reprint_Mixed_Customers_New_Packing_Slips_Warning")}
                        </p>
                    )}
                    {showLegacyTemplateOptions && (
                        <WmsContainer>
                            <WmsDropdown
                                id={"tempaltes"}
                                name="shippingLabelSelectedIndex"
                                wmsSelector={this.state.selector + "tempaltes"}
                                options={this.state.shippingLabelOptions}
                                value={this.state.shippingLabelSelectedIndex}
                                onChangeFunc={this.handleChangeShippingLabel}
                                label={this.translate("Label_Template")}
                                valueField={"PackageDefId"}
                                textField={"Name"}
                                applyIndex={true}
                            />
                        </WmsContainer>
                    )}
                    {showPackingSlipOptions && (
                        <WmsContainer title={this.getCustomerContainerTitle()}>
                            <WmsDropdown
                                id="indexOptionsPackingReports"
                                name="indexOptionsPackingReports"
                                label={this.translate("Label_Packing_Slip_Template")}
                                wmsSelector={this.state.selector + "PackingSlipReport"}
                                value={this.state.indexOptionsPackingReports}
                                onChangeFunc={this.handleChangeEvent}
                                options={this.state.optionsPackingReports}
                                textField="Name"
                                valueField="value"
                            />
                            {this.showPackingSlipLayout() && (
                                <WmsDropdown
                                    id="indexPapiPackSlipScope"
                                    name="indexPapiPackSlipScope"
                                    label={this.translate("Label_PapiPackSlipLayout")}
                                    showLabelInfoIcon={true}
                                    labelInfoTooltipText={this.translate("Tooltip_PapiPackSlipLayout")}
                                    wmsSelector={this.state.selector + "PapiPackSlipLayout"}
                                    value={this.state.indexPapiPackSlipScope || "shipment"}
                                    onChangeFunc={this.handleChangeEvent}
                                    options={this.optionsPapiPackSlipScope}
                                    valueField="value"
                                    textField="text"
                                />
                            )}
                        </WmsContainer>
                    )}
                </div>
                <div className="footer-btn-holder">
                    <WmsButton
                        id={this.state.selector + "cancel"}
                        name={this.state.selector + "cancel"}
                        label={this.translate("Label_Cancel")}
                        wmsSelector={this.state.selector + "cancel"}
                        onClickFunc={this.props.onCloseReprintShippingLabel}
                        icon="fa-ban"
                        buttonType="yellow"
                    />
                    <WmsButton
                        id={this.state.selector + "generate"}
                        label={this.translate("Label_Generate")}
                        wmsSelector={this.state.selector + "generate"}
                        onClickFunc={this.generateLabel}
                        icon="fa-floppy-o"
                        disabled={generateDisabled}
                        showToolTip={isPapiPackageLayoutBlocked}
                        tooltipText={isPapiPackageLayoutBlocked
                            ? this.translate("Label_Packing_Slips_Must_Be_Packed")
                            : ""}
                        loading={this.state.shippingLabelGenerateGif}
                    />
                </div>
            </WmsModel>
        );
    }
}
